import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { taskService } from '../services/taskService'
import { useTaskPanel } from '../contexts/TaskPanelContext'
import { useAuth } from '../contexts/AuthContext'
import { Task } from '../types/task'
import './TaskNotificationBadge.css'

export function TaskNotificationBadge() {
  const { isOpen, setUnreadCount } = useTaskPanel()
  const { user } = useAuth()

  const { data: outstandingTasks } = useQuery<Task[]>({
    queryKey: ['tasks', 'outstanding', user?.id],
    queryFn: async () => {
      if (!user?.id) return []
      const assigned = await taskService.getAssigned(user.id)
      return assigned.filter(
        (task) =>
          task.status !== 'completed' &&
          task.status !== 'resolved' &&
          task.status !== 'cancelled'
      )
    },
    enabled: !!user?.id,
    refetchInterval: 30000, // Poll every 30 seconds
  })

  useEffect(() => {
    if (outstandingTasks) {
      setUnreadCount(outstandingTasks.length)
    }
  }, [outstandingTasks, setUnreadCount])

  const count = outstandingTasks?.length ?? 0

  if (count === 0 || isOpen) return null

  return (
    <span className="task-notification-badge" aria-label={`${count} open tasks assigned to you`}>
      {count > 99 ? '99+' : count}
    </span>
  )
}

